import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Map2d from '../src/2d';
import Map3d from '../src/3d';
import { convertLocation, convertMeasurement, reconvertLocation, visibleSizeAtZDepth } from '@blade-sxp/map/utils';
import { formatBackground, formatRoiList, formatDomList, formatDeviceList, formatLineList, formatPathList, formatImageList, formatPersonList, formatHeatMapList, formatHeatMapComplexList, formatCarParkingList, } from '@blade-sxp/map/utils/format-ele';
import MapLoading from '@blade/common/components/map-loading/index.vue';
let baseMapComponent = null;
let BaseMap = class BaseMap extends Vue {
    toolTipsList;
    roiList;
    videoList;
    deviceList;
    heatMapList;
    lineList;
    pathList;
    imageList;
    personList;
    mapUrl;
    mapId;
    mapType;
    debug;
    zoom;
    maxZoom;
    minZoom;
    mode;
    enableRotate;
    autoRotate;
    interactEnable;
    mouseLeft;
    mouseMiddle;
    operationMode;
    travelInitialPosition;
    mouseRight;
    backgroundColor;
    mainAngle;
    sunAngle;
    weather;
    mapClick;
    mapMouseMove;
    mapMousedown;
    mapMouseup;
    carParkingList;
    useOcTree;
    elements = [];
    visibleSize = null;
    map = null;
    mapUrlInfo = null;
    isMounted = false;
    mapData = new Map();
    memeryEleKeys = [];
    oldMapUrl = '';
    delayTimer = 0;
    collectElements = new Map(); // 数据源
    currMapType = null;
    progressNumber = 0;
    loading = false;
    ocTreeLoading = false;
    mapBoxStyle = {
        width: '100%',
        height: '100%',
    };
    get mapList() {
        return {
            // toolTipsList: this.toolTipsList,
            // roiList: this.roiList,
            // deviceList: this.deviceList,
            // heatMapList: this.heatMapList,
            // lineList: this.lineList,
            // imageList: this.imageList,
            // personList: this.personList,
            // carParkingList: this.carParkingList,
            // pathList: this.pathList,
            mapUrlInfo: this.mapUrlInfo,
            mode: this.mode,
            mapType: this.mapType,
            mainAngle: this.mainAngle,
            isMounted: this.isMounted,
            interactEnable: this.interactEnable,
        };
    }
    onChangeToolTipsList() {
        this.singleMapDataChange('toolTipsList');
    }
    onChangeRoiList() {
        this.singleMapDataChange('roiList');
    }
    onChangeDeviceList() {
        this.singleMapDataChange('deviceList');
    }
    onChangeHeatMapList() {
        this.singleMapDataChange('heatMapList');
    }
    onChangeLineList() {
        this.singleMapDataChange('lineList');
    }
    onChangePathList() {
        this.singleMapDataChange('pathList');
    }
    onChangeDrawLinePointList() {
        this.singleMapDataChange('drawLinePointList');
    }
    onChangeImageList() {
        this.singleMapDataChange('imageList');
    }
    onChangePersonList() {
        this.singleMapDataChange('personList');
    }
    onChangeCarParkingList() {
        this.singleMapDataChange('carParkingList');
    }
    onChangeMap() {
        if (!this.background[0]?.renderProps?.url)
            return;
        if ((this.background[0]?.renderProps?.is3D && this.currMapType === '3D-Three.js') ||
            (!this.background[0]?.renderProps?.is3D && this.currMapType === '2D')) {
            const key = 'background';
            baseMapComponent?._handleElementChange(key, this.background);
        }
    }
    onBackgroundColor(nv) {
        if (baseMapComponent)
            baseMapComponent.mapBackgroundColor = nv;
    }
    get background() {
        const info = this.mapUrlInfo || { width: 0, height: 0, url: '', is3D: false };
        const background = this.mapUrlInfo
            ? [
                formatBackground(info, this.onStart, this.onProgress, this.onEnd, this.onError, this.roiList || [], this.videoList || [], this.mode || '', this.mainAngle, this.onComplete),
            ]
            : [];
        return background;
    }
    async singleMapDataChange(key) {
        this.mapData.set(key, this[key]);
        if (this.mapType === '2D' && (!this.oldMapUrl || this.mapUrl !== this.oldMapUrl)) {
            !this.memeryEleKeys.includes(key) && this.memeryEleKeys.push(key); // 2D地图依赖图片长宽，需等图片加载完毕
            return;
        }
        let info = this.mapUrlInfo || { width: 0, height: 0, url: '', is3D: this.mapType === '3D-Three.js' };
        let targetData = [];
        if (key === 'toolTipsList') {
            targetData = this.toolTipsList ? formatDomList(this.toolTipsList, info) : [];
        }
        else if (key === 'heatMapList') {
            const heatmaps = this.heatMapList ? formatHeatMapList(this.heatMapList, info, this.mode || '') : [];
            const heatmapcomplexs = this.heatMapList ? formatHeatMapComplexList(this.heatMapList, info) : [];
            targetData = [...heatmaps, ...heatmapcomplexs];
        }
        else if (key === 'roiList') {
            targetData = this.roiList ? formatRoiList(this.roiList, info) : [];
        }
        else if (key === 'deviceList') {
            targetData = this.deviceList ? formatDeviceList(this.deviceList, info) : [];
        }
        else if (key === 'lineList') {
            targetData = this.lineList ? formatLineList(this.lineList, info) : [];
        }
        else if (key === 'pathList') {
            targetData = this.pathList ? formatPathList(this.pathList, info) : [];
        }
        else if (key === 'imageList') {
            targetData = this.imageList ? formatImageList(this.imageList, info) : [];
        }
        else if (key === 'personList') {
            targetData = this.personList ? formatPersonList(this.personList, info) : [];
        }
        else if (key === 'carParkingList') {
            targetData = this.carParkingList ? formatCarParkingList(this.carParkingList, info) : [];
        }
        this.collectElementData(key, targetData);
    }
    collectElementData(key, data) {
        this.collectElements.set(key, data);
        if (this.delayTimer)
            return;
        this.delayTimer = window.setTimeout(() => {
            window.clearTimeout(this.delayTimer);
            this.delayTimer = 0;
            baseMapComponent?.dealElementData(this.collectElements);
            this.collectElements.clear();
        }, 0);
    }
    // get mapInstance() {
    //   return { map: this.map, elements: this.elements, mapId: this.mapId };
    // }
    get mapUrlAndvisibleSize() {
        return { mapUrl: this.mapUrl, visibleSize: this.visibleSize, mapType: this.mapType };
    }
    handleRotation(val) {
        baseMapComponent?.setAutoRotate(val);
    }
    handleOperationMode() {
        this.setOperationMode(this.operationMode);
    }
    handleTravelInitialPosition() {
        this.setPersonInitPosition(this.travelInitialPosition);
    }
    async handleMapUrlAndvisibleSize(val) {
        const { mapUrl, visibleSize, mapType } = val;
        if (mapType === '3D-Three.js' || /\.gltf$/.test(this.mapUrl || '')) {
            // 存在异步问题，初始mapType为2d，增加对mapUrl校验
            this.mapUrlInfo = {
                url: mapUrl,
                width: 0,
                height: 0,
                id: mapUrl,
                is3D: true,
                useOcTree: this.useOcTree,
            };
            return;
        }
        if (mapUrl && visibleSize) {
            try {
                const info = await convertMeasurement(mapUrl, visibleSize);
                this.$emit('mapUrlLoad');
                if (info) {
                    this.mapUrlInfo = {
                        url: mapUrl,
                        width: info.width,
                        height: info.height,
                        id: 'backgroundUrl',
                        is3D: false,
                    };
                }
                else {
                    this.mapUrlInfo = null;
                }
                this.oldMapUrl = mapUrl;
                this.memeryEleKeys.forEach((item) => this.singleMapDataChange(item));
                this.memeryEleKeys = [];
            }
            catch (err) {
                this.mapUrlInfo = null;
                console.log('地图加载失败');
            }
        }
        else {
            this.mapUrlInfo = null;
        }
    }
    /**
     * 监听源数据的变化
     */
    handleMapDataChange(value, preValue) {
        const { 
        // toolTipsList,
        // roiList,
        // deviceList,
        // heatMapList,
        // lineList,
        // imageList,
        // personList,
        // carParkingList,
        mapUrlInfo, mode, 
        // mainAngle,
        mapType, isMounted, interactEnable, } = value;
        if (mapType === '3D-Three.js' && mapUrlInfo?.is3D === false)
            return;
        if (mapType === '2D' && mapUrlInfo?.is3D === true)
            return;
        // const info = mapUrlInfo || { width: 0, height: 0, url: '', is3D: false };
        // // if (mapUrlInfo) {
        // const heatmaps = heatMapList ? formatHeatMapList(heatMapList, info, mode) : [];
        // const heatmapcomplexs = heatMapList ? formatHeatMapComplexList(heatMapList, info, mode) : [];
        // const tooltips = toolTipsList ? formatDomList(toolTipsList, info) : [];
        // const rois = roiList ? formatRoiList(roiList, info) : [];
        // const devices = deviceList ? formatDeviceList(deviceList, info) : [];
        // const lines = lineList ? formatLineList(lineList, info) : [];
        // const images = imageList ? formatImageList(imageList, info) : [];
        // const persons = personList ? formatPersonList(personList, info) : [];
        // const [cars = [], parkings = []] = carParkingList?.length ? formatCarParkingList(carParkingList, info) : [];
        // const background = mapUrlInfo
        //   ? [formatBackground(info, this.onStart, this.onProgress, this.onEnd, this.onError, roiList, mode, mainAngle, this.onComplete)]
        //   : [];
        // const elements = [
        //   ...background,
        //   ...tooltips,
        //   ...rois,
        //   ...devices,
        //   ...heatmaps,
        //   ...heatmapcomplexs,
        //   ...lines,
        //   ...images,
        //   ...persons,
        //   ...cars,
        //   ...parkings,
        // ];
        // this.elements = elements;
        if (mapType !== preValue?.mapType && isMounted) {
            this.mapInit(mapType);
        }
        if (mapType === '3D-Three.js') {
            this.setInteractEnable(interactEnable);
            if (mode === 'normal' || !mode) {
                baseMapComponent?.setEnableDamping(true);
            }
            else {
                baseMapComponent?.setEnableDamping(false);
            }
            if (mode === 'verticalView') {
                baseMapComponent?.updateControls((controls) => {
                    controls.enableRotate = false;
                });
            }
            else {
                baseMapComponent?.updateControls((controls) => {
                    controls.enableRotate = true;
                });
            }
        }
        // } else {
        // this.elements = [];
        // }
    }
    /**
     * 监听map，elements，mapId,mapType的改变（与元素变化强相关）
     */
    // @Watch('mapInstance', { immediate: true })
    // handleElements(value: MapInstance, oldValue: MapInstance) {
    //   const { map, elements = [] } = value;
    //   if (map) {
    //     map.elements = elements;
    //   }
    // }
    /** 监听太阳角度变化 */
    onSunAngleChange() {
        if (!baseMapComponent)
            return;
        this.setSunPosition(this.sunAngle);
    }
    /** 监听天气变化 */
    onWeatherChange() {
        if (!baseMapComponent)
            return;
        this.setWeather(this.weather);
    }
    fetchOctree(url) {
        if (this.mapType === '3D-Three.js') {
            return baseMapComponent?.fetchOctree(url);
        }
    }
    /**
     * 还原
     */
    zoomReset() {
        baseMapComponent?.zoomReset();
    }
    /**
     * 缩小
     */
    zoomOut(num = 1) {
        baseMapComponent?.zoomOut(num);
    }
    /** 相机上升 */
    cameraUp(num = 0.1) {
        if (this.mapType === '3D-Three.js') {
            baseMapComponent?.cameraUp(num);
        }
    }
    /** 相机下降 */
    cameraDown(num = 0.1) {
        if (this.mapType === '3D-Three.js') {
            baseMapComponent?.cameraDown(num);
        }
    }
    /** 设置操作模式 */
    setOperationMode(mode) {
        if (this.mapType === '3D-Three.js') {
            baseMapComponent?.setOperationMode(mode);
        }
    }
    /**
     * 放大
     */
    zoomIn(num = 1) {
        baseMapComponent?.zoomIn(num);
    }
    moveToMesh(mesh) {
        baseMapComponent?.moveToMesh(mesh);
    }
    /** 是否启用射线 */
    setInteractEnable(val) {
        if (this.mapType === '3D-Three.js') {
            baseMapComponent?.setInteractEnable(val);
        }
    }
    /**
     * 3d贴图开始加载
     */
    onStart() {
        this.loading = true;
        this.$emit('onStart');
    }
    /**
     * 3d贴图加载中
     */
    onProgress(value) {
        if (value.total === 0)
            this.loading = false;
        this.progressNumber = Number((parseInt(String((value.loaded / value.total) * 1000)) / 10).toFixed(2));
        this.$emit('onProgress', value);
    }
    /**
     * 3d贴图加载完成
     */
    onEnd() {
        console.log('onEnd========');
        this.loading = false;
        this.$emit('onEnd');
    }
    /** gltf加载完成后执行 */
    onComplete() {
        if (this.mapType === '3D-Three.js') {
            const map = baseMapComponent;
            if (this.mode) {
                map?.setSceneBackground();
                map?.addAmbientLight();
                return;
            }
            // if (!map?.weather) {
            //   map?.resetWeather();
            // }
            // 全量更新天气
            map?.resetWeather();
            this.setWeather(this.weather, { update: true });
            this.setSunPosition(this.sunAngle);
        }
    }
    /**
     * 3d贴图加载失败
     */
    onError() {
        this.loading = false;
        this.$emit('onError');
    }
    /**
     * 统一点到一个平面
     */
    formatPointsToPlatform(vertices) {
        return baseMapComponent?.formatPointsToPlatform(vertices);
    }
    /**
     * 移动到地图特定点(世界坐标系)
     */
    moveToPoint(params) {
        if (this.mapType === '3D-Three.js') {
            baseMapComponent?.moveToPoint(params);
        }
        else {
            const { x, y, z, duration, cb } = params;
            const { x: mapX, y: mapY } = convertLocation(x, y, { width: this.mapUrlInfo?.width || 0, height: this.mapUrlInfo?.height || 0 });
            baseMapComponent?.moveToPoint({
                x: mapX,
                y: mapY,
                z: z,
                duration,
                cb,
            });
        }
    }
    /**
     * 移动到地图上的特定点(地图坐标系)
     */
    moveToMapPoint(params) {
        if (this.mapType === '3D-Three.js') {
            baseMapComponent?.moveToPoint(params);
        }
        else {
            const { x, y, z, duration, cb } = params;
            const { x: mapX, y: mapY } = convertLocation(x, y, { width: this.mapUrlInfo?.width || 0, height: this.mapUrlInfo?.height || 0 });
            baseMapComponent?.moveToPoint({
                x: mapX,
                y: mapY,
                z: z,
                duration,
                cb,
            });
        }
    }
    /**
     * 获取背景相关信息，（宽高url等）
     */
    getBackroundInfo() {
        return this.mapUrlInfo || {};
    }
    /**
     * 获取主视角
     */
    getMainAngle() {
        return baseMapComponent?.getMainAngle();
    }
    /**
     * 截图，快照
     */
    getScreenshot() {
        return baseMapComponent?.getScreenshot();
    }
    /**
     * 拿到世界坐标
     */
    getPosition(event) {
        return baseMapComponent?.getPosition(event);
    }
    /**
     * 根据坐标点返回世界坐标
     */
    getWorldPosition(vertices) {
        return baseMapComponent?.getWorldPosition(vertices);
    }
    removeMap() {
        baseMapComponent?.dispose();
    }
    // 清除画线工具group
    cleanToolGroup() {
        baseMapComponent?.cleanToolGroup();
    }
    // 设置地图行走模式出生点
    setPersonInitPosition(position) {
        console.log('进入行走模式');
        baseMapComponent?.collisionObject?.initCollisionObject(position);
    }
    /**
     * 转换坐标 dom=>地图
     */
    clientToMapPosition(x, y) {
        const worldPosition = baseMapComponent?.clientToMapPosition(x, y) || { x: 0, y: 0 };
        return {
            relativePosition: reconvertLocation(worldPosition.x, worldPosition.y, this.mapUrlInfo || { width: 0, height: 0 }),
            worldPosition,
        };
    }
    /**
     * 初始化地图
     */
    mapInit(mapType) {
        this.$emit('update', 3);
        this.removeMap();
        const elements = this.getMapData(this.mapData);
        if (!mapType)
            return;
        const Map = mapType === '2D' ? Map2d : mapType === '3D-Three.js' ? Map3d : null;
        if (!Map)
            return;
        const map = new Map({
            container: this.$refs['map-common-render'],
            debug: this.debug,
            zoom: this.zoom || 5,
            maxZoom: this.maxZoom || 10,
            minZoom: this.minZoom || 1,
            // elements: this.elements,
            elements: elements,
            enableRotate: this.enableRotate || false,
            autoRotate: this.autoRotate || false,
            mouseLeft: this.mouseLeft || 'PAN',
            mouseMiddle: this.mouseMiddle || 'DOLLY',
            mouseRight: this.mouseRight || 'ROTATE',
            backgroundColor: this.backgroundColor,
        });
        map.onload = () => {
            this.currMapType = mapType;
            baseMapComponent = map; //
            this.visibleSize = mapType === '2D' ? visibleSizeAtZDepth(0, map.camera) : null;
            this.loading = false;
            this.$emit('onload', map);
        };
        map.update = (value) => {
            this.$emit('update', value);
        };
        map.onClick = (target, targets, position, worldPosition) => {
            console.log('map.onClick');
            this.$emit('mapClick', target, targets, {
                relativePosition: reconvertLocation(position.x, position.y, this.mapUrlInfo || { width: 0, height: 0 }),
                worldPosition: this.mapUrlInfo?.is3D ? worldPosition : position,
            });
        };
        map.onMouseMove = (target, targets, position, worldPosition) => {
            this.$emit('mapMouseMove', target, targets, {
                relativePosition: reconvertLocation(position.x, position.y, this.mapUrlInfo || { width: 0, height: 0 }),
                worldPosition: this.mapUrlInfo?.is3D ? worldPosition : position,
            });
        };
        map.onMouseDown = (target, targets, position, worldPosition) => {
            this.$emit('mapMouseDown', target, targets, {
                relativePosition: reconvertLocation(position.x, position.y, this.mapUrlInfo || { width: 0, height: 0 }),
                worldPosition: this.mapUrlInfo?.is3D ? worldPosition : position,
            });
        };
        map.onMouseUp = (target, targets, position, worldPosition) => {
            this.$emit('mapMouseUp', target, targets, {
                relativePosition: reconvertLocation(position.x, position.y, this.mapUrlInfo || { width: 0, height: 0 }),
                worldPosition: this.mapUrlInfo?.is3D ? worldPosition : position,
            });
        };
        map.onMouseEnter = (target, targets) => {
            this.$emit('mapMouseEnter', target, targets);
        };
        map.onMouseLeave = (target, targets) => {
            this.$emit('mapMouseLeave', target, targets);
        };
    }
    getMapData(data) {
        let result = [];
        Object.values(data).forEach((item) => {
            result.concat(item);
        });
        return result;
    }
    setSunPosition(angle) {
        if (this.mapType !== '3D-Three.js') {
            return;
        }
        baseMapComponent?.setSunPosition(+angle);
    }
    setWeather(weather, config) {
        if (this.mapType !== '3D-Three.js') {
            return;
        }
        baseMapComponent?.setWeather(weather, config);
    }
    mounted() {
        this.mapInit(this.mapType);
        this.handleMapUrlAndvisibleSize(this.mapUrlAndvisibleSize);
        this.isMounted = true;
    }
    beforeDestroy() {
        baseMapComponent?.dispose();
        baseMapComponent = null;
    }
};
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseMap.prototype, "toolTipsList", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseMap.prototype, "roiList", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseMap.prototype, "videoList", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseMap.prototype, "deviceList", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseMap.prototype, "heatMapList", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseMap.prototype, "lineList", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseMap.prototype, "pathList", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseMap.prototype, "imageList", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseMap.prototype, "personList", void 0);
__decorate([
    Prop({ type: String, default: '' })
], BaseMap.prototype, "mapUrl", void 0);
__decorate([
    Prop({ type: String, default: '' })
], BaseMap.prototype, "mapId", void 0);
__decorate([
    Prop({ type: String, default: '2D' })
], BaseMap.prototype, "mapType", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseMap.prototype, "debug", void 0);
__decorate([
    Prop({ type: Number, default: 5 })
], BaseMap.prototype, "zoom", void 0);
__decorate([
    Prop({ type: Number, default: 10 })
], BaseMap.prototype, "maxZoom", void 0);
__decorate([
    Prop({ type: Number, default: 1 })
], BaseMap.prototype, "minZoom", void 0);
__decorate([
    Prop({ type: String, default: '' })
], BaseMap.prototype, "mode", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseMap.prototype, "enableRotate", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseMap.prototype, "autoRotate", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], BaseMap.prototype, "interactEnable", void 0);
__decorate([
    Prop({ type: String, default: 'PAN' })
], BaseMap.prototype, "mouseLeft", void 0);
__decorate([
    Prop({ type: String, default: 'DOLLY' })
], BaseMap.prototype, "mouseMiddle", void 0);
__decorate([
    Prop({ type: String, default: 'sandTable' })
], BaseMap.prototype, "operationMode", void 0);
__decorate([
    Prop()
], BaseMap.prototype, "travelInitialPosition", void 0);
__decorate([
    Prop({ type: String, default: 'ROTATE' })
], BaseMap.prototype, "mouseRight", void 0);
__decorate([
    Prop({ type: String, default: '#1e1e1e' })
], BaseMap.prototype, "backgroundColor", void 0);
__decorate([
    Prop()
], BaseMap.prototype, "mainAngle", void 0);
__decorate([
    Prop({ type: Number, default: 35 })
], BaseMap.prototype, "sunAngle", void 0);
__decorate([
    Prop({ type: String, default: 'sunny' })
], BaseMap.prototype, "weather", void 0);
__decorate([
    Prop({ type: Function, default: (e) => { } })
], BaseMap.prototype, "mapClick", void 0);
__decorate([
    Prop({ type: Function, default: (e) => { } })
], BaseMap.prototype, "mapMouseMove", void 0);
__decorate([
    Prop({ type: Function, default: (e) => { } })
], BaseMap.prototype, "mapMousedown", void 0);
__decorate([
    Prop({ type: Function, default: (e) => { } })
], BaseMap.prototype, "mapMouseup", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseMap.prototype, "carParkingList", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], BaseMap.prototype, "useOcTree", void 0);
__decorate([
    Watch('toolTipsList', { deep: true, immediate: true })
], BaseMap.prototype, "onChangeToolTipsList", null);
__decorate([
    Watch('roiList', { deep: true, immediate: true })
], BaseMap.prototype, "onChangeRoiList", null);
__decorate([
    Watch('deviceList', { deep: true, immediate: true })
], BaseMap.prototype, "onChangeDeviceList", null);
__decorate([
    Watch('heatMapList', { deep: true, immediate: true })
], BaseMap.prototype, "onChangeHeatMapList", null);
__decorate([
    Watch('lineList', { deep: true, immediate: true })
], BaseMap.prototype, "onChangeLineList", null);
__decorate([
    Watch('pathList', { deep: true, immediate: true })
], BaseMap.prototype, "onChangePathList", null);
__decorate([
    Watch('drawLinePointList', { deep: true, immediate: true })
], BaseMap.prototype, "onChangeDrawLinePointList", null);
__decorate([
    Watch('imageList', { deep: true, immediate: true })
], BaseMap.prototype, "onChangeImageList", null);
__decorate([
    Watch('personList', { deep: true, immediate: true })
], BaseMap.prototype, "onChangePersonList", null);
__decorate([
    Watch('carParkingList', { deep: true, immediate: true })
], BaseMap.prototype, "onChangeCarParkingList", null);
__decorate([
    Watch('background', { deep: true }),
    Watch('currMapType')
], BaseMap.prototype, "onChangeMap", null);
__decorate([
    Watch('backgroundColor')
], BaseMap.prototype, "onBackgroundColor", null);
__decorate([
    Watch('autoRotate')
], BaseMap.prototype, "handleRotation", null);
__decorate([
    Watch('operationMode', { immediate: true })
], BaseMap.prototype, "handleOperationMode", null);
__decorate([
    Watch('travelInitialPosition', { immediate: true })
], BaseMap.prototype, "handleTravelInitialPosition", null);
__decorate([
    Watch('mapUrlAndvisibleSize')
], BaseMap.prototype, "handleMapUrlAndvisibleSize", null);
__decorate([
    Watch('mapList', { immediate: true, deep: true })
], BaseMap.prototype, "handleMapDataChange", null);
__decorate([
    Watch('sunAngle')
], BaseMap.prototype, "onSunAngleChange", null);
__decorate([
    Watch('weather')
], BaseMap.prototype, "onWeatherChange", null);
BaseMap = __decorate([
    Component({
        name: 'BaseMap',
        components: { MapLoading },
    })
], BaseMap);
export default BaseMap;
